// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WnUX","top":"styles_top__1vJRp","left":"styles_left__3mdeG","description":"styles_description__3vi8Y"};